// @flow

import { RemoveButton } from '@gandi/cart';

type Props = {
  /** action to set / unset confirmation step  */
  fireConfirmationStep: boolean => void,
};

export default function RemoveButtonFF({
  fireConfirmationStep,
}: Props): React.MixedElement {
  return <RemoveButton handleRemoveAction={() => fireConfirmationStep(true)} />;
}
